/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Transaction { 
    theDate?: string | null;
    docType: string;
    folderId: number;
    mode: number;
    folderName: string;
    id: number;
    docClass: number;
    docPathFolderId: number;
    aUser: string;
    docNumber?: string | null;
    docNumberText?: string | null;
    amount?: number | null;
    currency?: string | null;
    amountBC?: number | null;
    currencyId?: number | null;
    clientId?: number | null;
    debitAccount?: string | null;
    debitAccountId?: number | null;
    debitClientId?: number | null;
    debDescr?: string | null;
    creditAccount?: string | null;
    crdDescr?: string | null;
    creditAccountId?: number | null;
    creditClientId?: number | null;
    fontColor: number;
    fontStyle: number;
    metaDocumentId?: number;
    docClassShortName: string;
    info?: string | null;
}

